(function initMundskaenkenLegacyStorefrontLinks() {
  const storefrontHosts = new Set(['mundskaenken.com', 'www.mundskaenken.com']);
  const pathRules = [
    { source: '/links', target: '/apps/kundeprofil/links', exact: true },
    {
      source: '/apps/kundeprofil/flaskepost/checkout',
      target: '/apps/kundeprofil/vinposten/legacy-flaskepost-checkout',
      exact: true,
    },
    {
      source: '/flaskepost/checkout',
      target: '/apps/kundeprofil/vinposten/legacy-flaskepost-checkout',
      exact: true,
    },
    { source: '/flaskepost', target: '/apps/kundeprofil/vinposten' },
    { source: '/pages/vinposten', target: '/apps/kundeprofil/vinposten' },
    { source: '/vinposten', target: '/apps/kundeprofil/vinposten' },
  ];

  if (!storefrontHosts.has(String(window.location.hostname || '').toLowerCase())) return;

  function canonicalPath(pathname) {
    const originalPath = String(pathname || '');
    let path = originalPath;
    for (let pass = 0; pass < pathRules.length; pass += 1) {
      const rule = pathRules.find(function(candidate) {
        return candidate.exact
          ? path === candidate.source || path === candidate.source + '/'
          : path === candidate.source || path.startsWith(candidate.source + '/');
      });
      if (!rule) break;
      path = rule.exact
        ? rule.target
        : rule.target + path.slice(rule.source.length);
    }
    return path === originalPath ? '' : path;
  }

  function hasPathTraversal(value) {
    const encodedPath = String(value || '').split(/[?#]/, 1)[0];
    try {
      return /(?:^|\/)\.{1,2}(?:\/|$)/.test(decodeURIComponent(encodedPath));
    } catch (_error) {
      return true;
    }
  }

  function canonicalParametricTarget(url) {
    let match = url.pathname.match(/^\/delivery\/select\/(\d{1,20})\/?$/);
    if (!match) match = url.pathname.match(/^\/delivery\/(\d{1,20})\/?$/);
    if (match) {
      const searchParams = new URLSearchParams(url.search);
      searchParams.set('tab', 'delivery');
      searchParams.set('customer_id', match[1]);
      return '/apps/kundeprofil?' + searchParams.toString() + url.hash;
    }

    match = url.pathname.match(/^\/delivery\/track\/([A-Za-z0-9_-]{20,128})(\/status)?\/?$/);
    if (match) {
      return '/apps/kundeprofil/levering/' + match[1] + (match[2] || '') + url.search + url.hash;
    }

    if (url.pathname === '/wine-library/descriptions.pdf') {
      return '/apps/kundeprofil/wine-library/descriptions.pdf' + url.search + url.hash;
    }
    return '';
  }

  function canonicalRelativeUrl(value) {
    try {
      const rawValue = String(value || '');
      if (hasPathTraversal(rawValue)) return '';
      const url = new URL(rawValue, window.location.href);
      if (
        url.protocol !== 'https:' ||
        url.port ||
        url.username ||
        url.password ||
        !storefrontHosts.has(url.hostname.toLowerCase())
      ) {
        return '';
      }
      const parametricTarget = canonicalParametricTarget(url);
      if (parametricTarget) return parametricTarget;
      const path = canonicalPath(url.pathname);
      return path ? path + url.search + url.hash : '';
    } catch (_error) {
      return '';
    }
  }

  const currentTarget = canonicalRelativeUrl(window.location.href);
  if (currentTarget) {
    // These root aliases render Dawn's 404, so move the browser to the fixed
    // same-store canonical app-proxy path before the 404 becomes interactive.
    window.location.replace(currentTarget);
    return;
  }

  function rewriteAttribute(element, attribute) {
    if (!element || !element.getAttribute || !element.setAttribute) return;
    const value = element.getAttribute(attribute);
    if (!value) return;
    const target = canonicalRelativeUrl(value);
    if (target) element.setAttribute(attribute, target);
  }

  function rewriteElement(element) {
    rewriteAttribute(element, 'href');
    rewriteAttribute(element, 'action');
    rewriteAttribute(element, 'formaction');
  }

  function rewriteTree(root) {
    rewriteElement(root);
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href], form[action], [formaction]').forEach(rewriteElement);
  }

  function startObserver() {
    rewriteTree(document);
    if (typeof MutationObserver !== 'function' || !document.documentElement) return;
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(rewriteTree);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('click', function(event) {
    const link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    rewriteAttribute(link, 'href');
    const submitter = event.target && event.target.closest ? event.target.closest('[formaction]') : null;
    rewriteAttribute(submitter, 'formaction');
  }, true);

  document.addEventListener('submit', function(event) {
    rewriteAttribute(event.target, 'action');
    rewriteAttribute(event.submitter, 'formaction');
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
